module.exports = __webpack_public_path__ + "static/media/manage-time.359c409b.jpg";